import React from "react";
import IncSitesList from "./inc_sites";

// Container for INC Sites: every site of the projects the user is assigned to
// (role level 1 sees all). Permission-gated by IncSite.view_all in the router.
const IncSitesPage: React.FC = () => {
  return <IncSitesList endpoint="/inc/sites/all" title="INC Sites" />;
};

export default IncSitesPage;
